import { OktaAuthService } from '../services/okta-auth.service';
import { HybridStorageService } from './services/hybrid-storage.service';
import { AuthStorageService } from './services/auth-storage.service';
import { RuntimeConfigService } from '../services/runtime-config.service';
import { DeepLinkService } from '../services/deep-link.service';
import { KeyboardService } from '../services/keyboard.service';
import { TranslationService } from '../services/translation.service';
import { Capacitor } from '@capacitor/core';

// Factory function to chain initializers
export function initializeApp(hybridStorage: HybridStorageService, authStorage: AuthStorageService,
  runtimeConfig: RuntimeConfigService, oktaAuthService: OktaAuthService,
  deepLinkService: DeepLinkService, _keyboardService: KeyboardService, translationService: TranslationService) {
  return async () => {
    // Initialize KeyboardService (just by having it injected, the constructor runs)
    // This ensures keyboard listeners are set up early
    // The underscore prefix indicates this parameter is intentionally unused


    await hybridStorage.ready;
    await authStorage.ready;        // Wait for auth storage
    await translationService.initialize(); // Initialize translation service with stored language

    // Check if app was launched with demo mode flag from native side
    if(Capacitor.isNativePlatform())
    {
      const urlParams = new URLSearchParams(window.location.search);
      const hasOktaCallback = urlParams.has('code') && urlParams.has('state');
      const hasDemoMode = urlParams.has('__demo_mode');
      if (hasDemoMode) {
        await runtimeConfig.enableDemoMode(true); // Persist during OAuth flow
      } else if (!hasOktaCallback) {
        // Only clear demo mode on normal launch (not OAuth callback)
        // OAuth callbacks should preserve demo mode from storage via initialize()
        const currentDemoMode = await hybridStorage.getItem<boolean>('DemoMode');
        const runtimeDemoMode = runtimeConfig.isDemoMode;

        // Only disable demo mode if both storage AND runtime config say it's not enabled
        // This prevents disabling demo mode that was just enabled via deep link
        if (!currentDemoMode && !runtimeDemoMode) {
          await runtimeConfig.disableDemoMode();
        }
      }
    }

    await runtimeConfig.initialize(); // Initialize runtime config (will restore demo mode from storage if needed)
    

    await oktaAuthService.initialize(); // Then initialize OktaAuthService with correct environment
    

    await deepLinkService.initializeDeepLinkListener(); // Finally initialize deep link listeners
    
  };
}
